import * as React from "react";
import { useTranslation } from 'react-i18next';
import '../../assets/css/help.general.scoped.css'
import "../../assets/css/help.scoped.css";
import {HelpLogo, HelperHelpDocsIcon} from "./HelperIcons";
import { Link } from "react-router-dom";
import {
  getHelpDocsbyLanguage
} from "../../utils/helpUrls";

export const HelpMenuList = ({ children, style, className }) => {
  const { t } = useTranslation();
  className = className && Array.isArray(className) ? className : className = [className];
  return (
    <div className={["dropdown", ...className]} style={{ ...style }}  >
      <span className={['btn', 'btn-secondary', 'dropdown-toggle']} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <div className=""
          style={{
            position: 'relative',
            width: '4rem',
            height: '4rem',
            marginTop: '-.8rem'
          }}
        >
          <HelpLogo props={{ width: '4rem', height: '4rem' }} />
        </div>
      </span>
      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li><Link className="dropdown-item" to="/help/faq">{/*Documentation*/ t("helpsupport.menu_documentation")}</Link></li>
        {/* <li><a  className="dropdown-item"  onClick={()=> startTour() } >Tour</a></li> */}
      </ul>
    </div>
  )
}


export const HelperDocsMenuList = ({style, className, startTour}={}) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const [isOpen, setIsOpen] = React.useState(false);

  className = className && Array.isArray(className) ? className : className = [className];

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const openDropdown = () => {
    setIsOpen(true);
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  const { faqPath, videoTutorialPath } = getHelpDocsbyLanguage(language);
  
  return (
    <div className={["dropdown", ...className]} style={{ ...style }}  >
      <span className={['btn', 'btn-secondary', 'dropdown-toggle']} type="button" id="dropdownMenuButton" onClick={toggleDropdown} aria-haspopup="true" aria-expanded={isOpen}>
        <div className=""
          style={{
            position: 'relative',
          }}
        >
          <HelperHelpDocsIcon />
        </div>
      </span>
      <ul
        className={`dropdown-menu dropdown-menu-right ${isOpen ? 'show' : ''}`}
        aria-labelledby="dropdownMenuButton">
        {(startTour !== false) &&
          <li>
            <a className="dropdown-item"
              onClick={() => {
                if (startTour) {
                  closeDropdown();
                  startTour();
                } else {
                  alert("error starting Tour");
                }
              }}
            >
              {t("helpsupport.menu_tour")}
            </a>
          </li>}
        <li><a target="_blank" rel="external" className="dropdown-item" href={faqPath}>{t("helpsupport.menu_documentation")}</a></li>
        <li><a target="_blank" rel="external" className="dropdown-item" href={videoTutorialPath}>{t("helpsupport.video_tutorial")}</a></li>
        <li><Link className="dropdown-item" to="/support_ticket">{t("helpsupport.support_form")}</Link></li>
      </ul>
    </div>
  )
}


export const WithHelperDocs = ({ children, style, className, startTour }) => {
  return (<>
    <div style={{ zIndex: 1000, position: 'fixed', right: '0px', top: '50%', transform: 'translateY(-50%)' }}>
      <HelperDocsMenuList style={style} className={className} startTour={startTour} />
    </div>
    {children}
  </>)
};

export const WithHelperDocsuseStart=({useStartTour ,  ...args})=>{
  const {startTour} = useStartTour();
  return WithHelperDocs({startTour, ...args});
}
